import { customSegmentRef } from './consts';
export default function(editor, opts = {}) {
  const bm = editor.BlockManager;

  if (opts.blocks.indexOf(customSegmentRef) >= 0) {
    const style = `
    <style>
    .${customSegmentRef} {
      min-height: 50px;
    }
    </style>
`;
    bm.add(customSegmentRef, {
      label: `
      <i class="webconnect-braces"></i><div>${opts.labelCustomSegment}</div>`,
      content: `<div class="${customSegmentRef}" data-gjs-type="${customSegmentRef}"></div>${style}`,
      category: opts.labelCustomSegmentCategory,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelCustomSegment
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
